import { useMemo } from 'react';

import {
  Configuration,
  CdmaControllerApi,
  CollaboratorsControllerApi,
  UserControllerApi,
  TetraFileControllerApi,
  TetraFileFolderControllerApi,
  ScoreControllerApi,
  TopLevelControlControllerApi,
  PropertiesControllerApi,
  InsurabilityControllerApi,
  EventLogControllerApi,
  CompletionLevelControllerApi,
  SafeguardControllerApi,
  ScoreAttributeControllerApi,
  ProductControllerApi,
  SafeguardCommentControllerApi,
  TetraFileDownloadLinkControllerApi,
  TetraFileDownloadControllerApi,
  FrameworkControllerApi,
  LabelControllerApi,
} from '@rtkwlf/syte-products';

import { useAuthContext } from '@packages/legacy/auth';
import { useOrganizationContext } from '@packages/legacy/organization-context';

import type { SyteClient } from './types';

export const useSyteApiMapig = (headers?: HeadersInit): SyteClient => {
  const { fetchApi } = useAuthContext();
  const { selectedOrganization } = useOrganizationContext();

  const apiClient = useMemo(() => {
    const baseUrl = `https://syte-papi.managedgw.${selectedOrganization.pod}-prod.arcticwolf.net`;

    const configuration = new Configuration({
      basePath: baseUrl,
      fetchApi,
    });
    return {
      configuration,
      cdmaApi: new CdmaControllerApi(configuration),
      collaboratorsApi: new CollaboratorsControllerApi(configuration),
      userApi: new UserControllerApi(configuration),
      fileApi: new TetraFileControllerApi(configuration),
      fileFolderApi: new TetraFileFolderControllerApi(configuration),
      fetchApi,
      scoreApi: new ScoreControllerApi(configuration),
      topControlApi: new TopLevelControlControllerApi(configuration),
      propertiesApi: new PropertiesControllerApi(configuration),
      insurabilityApi: new InsurabilityControllerApi(configuration),
      eventLogApi: new EventLogControllerApi(configuration),
      completionLevelApi: new CompletionLevelControllerApi(configuration),
      elementsApi: new SafeguardControllerApi(configuration),
      scoreAttributtesApi: new ScoreAttributeControllerApi(configuration),
      productsApi: new ProductControllerApi(configuration),
      commentsApi: new SafeguardCommentControllerApi(configuration),
      frameworkApi: new FrameworkControllerApi(configuration),
      fileDownloadLinkApi: new TetraFileDownloadLinkControllerApi(
        configuration,
      ),
      fileDownloadApi: new TetraFileDownloadControllerApi(configuration),
      labelsApi: new LabelControllerApi(configuration),
    };
  }, [fetchApi, selectedOrganization.pod]);

  return apiClient;
};
